'use client';

import React from 'react';
import styled from 'styled-components';

const YANDEX_CLIENT_ID = process.env.NEXT_PUBLIC_YANDEX_CLIENT_ID!;

export const YandexAuthRedirectButton: React.FC = () => {
  // Подробнее тут https://yandex.ru/dev/id/doc/ru/codes/code-url
  const handleLogin = () => {
    const redirectUri = `https://auth.plande.ru/auth/yandex`;
    const url = `https://oauth.yandex.ru/authorize?response_type=token&client_id=${YANDEX_CLIENT_ID}&redirect_uri=${encodeURIComponent(
      redirectUri
    )}&force_confirm=true`;
    window.location.href = url;
  };

  return (
    <Button onClick={handleLogin}>
      <Icon
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 44 44"
        aria-hidden="true"
        style={{
          borderRadius: 56
        }}
      >
        <rect width="44" height="44" fill="#FC3F1D"/><path d="M24.7407 33.9778H29.0889V9.04443H22.7592C16.3929 9.04443 13.0538 12.303 13.0538 17.1176C13.0538 21.2731 15.2187 23.6163 19.0532 26.1609L21.3832 27.6987L18.3927 25.1907L12.4667 33.9778H17.1818L23.5115 24.5317L21.3098 23.0671C18.6496 21.2731 17.3469 19.8818 17.3469 16.8613C17.3469 14.2068 19.2183 12.4128 22.7776 12.4128H24.7223V33.9778H24.7407Z" fill="white"/>
      </Icon>
      Войти через Яндекс
    </Button>
  );
};

/* ---------------- styled-components ---------------- */

const Button = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;

  border: none;
  border-radius: 56px;
  background-color: #000;
  color: #fff;

  height: 56px;
  min-width: 280px;
  padding: 14px 24px 14px 18px;

  font-size: 18px;
  line-height: 20px;
  font-weight: 500;

  cursor: pointer;
  transition: background-color 0.3s, opacity 0.3s;

  &:hover {
    background-color: #222;
  }

  &:active {
    opacity: 0.8;
  }
`;

const Icon = styled.svg`
  width: 24px;
  height: 24px;
  flex-shrink: 0;
`;

export default YandexAuthRedirectButton;
